/**
 * "Privacy & your rights" — Trust section (ADR-0074).
 * Reconciled from the memory model (persistent-per-end-user vs ephemeral, consent-
 * gated — described at the docs level the existing /docs/memory page owns), the
 * data-subject request intake (email, 24-hour acknowledgement / 30-day SLA), and the
 * GDPR/CCPA rights in product/trust/privacy.md. Fulfilment is partly an operator
 * process, so phrased as rights you can exercise, not one-click automation.
 */
import type { DocPageContent } from '../types';

export const TRUST_PRIVACY_PAGE: DocPageContent = {
  slug: 'trust/privacy',
  titleKey: 'docs.trust.privacy.title',
  descriptionKey: 'docs.trust.privacy.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.privacy.lead' },

    { kind: 'heading', level: 2, id: 'memory', textKey: 'docs.trust.privacy.memory.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.privacy.memory.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.privacy.memory.note.title',
      textKey: 'docs.trust.privacy.memory.note.body',
      links: {
        memory: { target: { docSlug: 'memory' }, labelKey: 'docs.trust.privacy.memory.note.link' },
      },
    },

    { kind: 'heading', level: 2, id: 'pii', textKey: 'docs.trust.privacy.pii.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.privacy.pii.body' },

    { kind: 'heading', level: 2, id: 'rights', textKey: 'docs.trust.privacy.rights.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.privacy.rights.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.trust.privacy.right.access.term',
          descKey: 'docs.trust.privacy.right.access.desc',
        },
        {
          termKey: 'docs.trust.privacy.right.erasure.term',
          descKey: 'docs.trust.privacy.right.erasure.desc',
        },
        {
          termKey: 'docs.trust.privacy.right.portability.term',
          descKey: 'docs.trust.privacy.right.portability.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'requests', textKey: 'docs.trust.privacy.requests.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.privacy.requests.body' },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.trust.privacy.requests.tip.title',
      textKey: 'docs.trust.privacy.requests.tip.body',
      links: {
        privacy: { target: { path: '/trust/privacy' }, labelKey: 'docs.trust.common.link.privacy' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.privacy.next.compliance.title',
          textKey: 'docs.trust.privacy.next.compliance.text',
          to: { docSlug: 'trust/compliance' },
        },
        {
          titleKey: 'docs.trust.privacy.next.data.title',
          textKey: 'docs.trust.privacy.next.data.text',
          to: { docSlug: 'trust/data' },
        },
      ],
    },
  ],
};
